const otpStrings = {
  legacy: {
    title: 'Forgot password',
    toast: 'New code sent',
    header: {
      forgotFlowTitle: 'We sent you a text',
    },
    description: {
      forgotFlowDescription:
        'Enter the 6-digit code we sent to your phone number ending in ',
    },
    banner: {
      title: 'Don’t share this code',
      description:
        'A Varo customer representative will never ask for this code.',
    },
    buttons: {
      resend: 'Resend code ',
      next: 'Next',
      requestNewCode: 'Request a new code',
    },
    errors: {
      codeRequired: 'Code required',
      codeNotMatch: 'Code doesn’t match',
    },
  },
  genericError: "There's an issue on our end. Please try again later.",
  deviceVerification: {
    header: 'Confirm your identity',
    description:
      "It's for your security. Enter the 6-digit code we sent to your phone number ending in ",
  },
  common: {
    header: 'Verify your phone number',
    description: "We'll use the number ending in ",
    description1: ' to contact you and keep your account safe.',
  },
  emailVerification: {
    header: 'Enter verification code',
    description: 'Click on the link we sent to your email at ',
    subDescription: 'You can find your verification code in the same email.',
    descriptionEmail: 'Enter the code we sent to your email address {{email}}.',
  },
  phoneVerification: {
    header: 'Enter verification code',
    description:
      'Enter the code we sent to your phone number ending in {{phone}}.',
  },
  emailLinkVerification: {
    title: 'Change phone number',
    header: 'Check your email',
    description: 'We sent a verification email to {{emailId}}.',
    newLinkSent: 'New link sent.',
    buttons: {
      openEmail: 'Go to email',
    },
  },
  verifyIdentity: {
    title: 'Login',
    header: 'Confirm your identity',
    description: `It's for your security. We sent a verification email to {{emailId}}.`,
    newLinkSent: 'New link sent.',
    buttons: {
      openEmail: 'Go to email',
    },
  },
  buttons: {
    resendCode: 'Resend code',
    resendLink: 'Resend link',
    submit: 'Next',
    secondary: 'Cancel',
    resendCodeWaitMessage: 'You can resend the code in',
    resendLinkWaitMessage: 'You can resend the link in',
  },
  newCodeSent: 'New code sent.',
  errorSendingCode: 'Code failed to send. Please try again.',
  invalidCode: 'The code you entered is incorrect.',
  otpBanner: {
    title: 'Don’t share this code',
    description: 'A Varo customer representative will never ask for this code.',
  },
  otpError: {
    codeFiledToSend: 'Code failed to send, please try again.',
    tryAgainMessage: 'That didn’t work. Please try again.',
  },
  addressRiskChallenge: {
    checkEmail: {
      header: 'Check your email',
      description: 'Enter the 6-digit code we sent to the email ',
    },
  },
};

export default otpStrings;
